import state from './searchState'
import mutations from './searchMutation'
import getters from './searchGetters'
import actions from './searchAction'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
